import { CustomerName } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/customer'

import { sanitizeLyraCode } from '../../../../common/utils/utils'
import { validateLyraCode } from '../../../../requestPayment/data/requestPaymentActions'

const ERROR_TYPE_MESSAGES: Record<string, Record<string, string>> = {
  INVALID_LYRA_CODE: {
    default: 'Invalid Lyra code. Please re-enter or confirm with your client.',
    [CustomerName.LEIDOS]: 'Invalid Lyra Code. Please re-enter or validate in the client profile or calendar.',
  },
  VALIDATION_UNAVAILABLE: {
    default: 'lyraCode cannot be validated at this time. Please try again later.',
  },
}

const getLyraCodeErrorMessage = (response: any, companyValue: string | undefined): string => {
  if (response.error_type && ERROR_TYPE_MESSAGES[response.error_type]) {
    const messages = ERROR_TYPE_MESSAGES[response.error_type]
    return (companyValue && messages[companyValue]) || messages.default
  }
  return response.error
}

const paymentRequestAsyncValidate = ($$values: any, dispatch: any) => {
  const lyraCode = sanitizeLyraCode($$values.get('lyra_code', ''))
  const companyRaw = $$values.get('company')
  const companyArray = companyRaw?.toJS?.() ?? companyRaw
  const customerName = companyArray?.[0]?.value
  return dispatch(validateLyraCode(lyraCode)).then((response: any) => {
    if (response.error) {
      throw { lyra_code: getLyraCodeErrorMessage(response, customerName) }
    }
  })
  // TODO: handle other errors
}

export default paymentRequestAsyncValidate
